import { EMAIL_COMMUNICATION_TYPE_INFO_TEXT_MAP, PHONE_COMMUNICATION_TYPE_INFO_TEXT_MAP } from '../constants';
function getCommunicationTypeInfo(_ref) {
  var _ref$communicationTyp = _ref.communicationType,
    communicationType = _ref$communicationTyp === void 0 ? '' : _ref$communicationTyp,
    _ref$email = _ref.email,
    email = _ref$email === void 0 ? false : _ref$email,
    _ref$phone = _ref.phone,
    phone = _ref$phone === void 0 ? false : _ref$phone;
  if (!communicationType) {
    return '';
  }
  if (email) {
    return EMAIL_COMMUNICATION_TYPE_INFO_TEXT_MAP[communicationType.toUpperCase()];
  }
  if (phone) {
    return PHONE_COMMUNICATION_TYPE_INFO_TEXT_MAP[communicationType.toUpperCase()];
  }
  return '';
}
export default getCommunicationTypeInfo;
//# sourceMappingURL=getCommunicationTypeInfo.js.map